import styled from '@emotion/styled';
import { theme } from '~/theme';
import { StyledCloseIcon } from '~/features/productList/components/FilterBar/SelectedFacets/SelectedFacets.styles';
import { StoreSearchInput } from '~/shared/components/StoreSearchInput';

export const StoresWrapper = styled.ul(() => ({
    width: '100%',
    listStyle: 'none',
    marginBottom: '80px',
}));

export const StoreWrapper = styled.li(() => ({
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    width: '100%',
    listStyle: 'none',
    padding: theme.space[3],
    border: `1px solid ${theme.colors.brownLight}`,
    borderRadius: theme.sizes.cornerRadius,
    marginBottom: theme.space[3],
}));

export const StoreContent = styled.div(() => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
}));

export const FormTitle = styled.div(({ theme }) => ({
    fontSize: theme.fontSizes.lg,
    margin: `${theme.space[3]} 0 ${theme.space[1]}  0`,
    fontWeight: theme.fontWeights.medium,
    textTransform: 'uppercase',
}));

export const StoreTitle = styled.div(() => ({
    fontSize: theme.fontSizes.xs,
    fontWeight: theme.fontWeights.medium,
}));

export const StoreAdress = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    fontSize: theme.fontSizes.xs,
    fontWeight: theme.fontWeights.regular,
    marginTop: theme.space[2],
    lineHeight: theme.fontSizes.lg,
}));

export const ClickAndCollectStoresWrapper = styled.div(() => ({
    padding: `0 ${theme.space[4]}`,
}));

export const StoresCloseWrapper = styled.div(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: theme.space[3],
}));

export const StoresCloseIcon = styled(StyledCloseIcon)(() => ({
    width: 15,
    height: 15,
    marginLeft: theme.space['2'],
    marginTop: 2,
    cursor: 'pointer',
    padding: 0,
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledStoreSearchInput = styled(StoreSearchInput)(() => ({
    width: '100%',
    padding: `${theme.space[3]} 0`,
    borderBottom: 'none',
    textTransform: 'uppercase',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    background: theme.colors.white,
}));
